module.exports = __webpack_public_path__ + "static/media/resizeTwo.1480f162.JPG";